$shm_hitalama_map_widget_float_viewport_frame $shm_hitalama_map_widget_float
	head_showed true
	controls /
		<= Num $shm_hitalama_map_widget_float_viewport_frame_number
			value? <=> text? \1
			options <= options /
			style *
				transform <= num_style_transform \
	Contextmenu_body $shm_hitalama_map_page_contextmenu
		Map_page <= Map_page
	settings_content /
		<= Width_label $mol_paragraph
			title \Ширина
		<= Width $mol_number
			value? <=> width?
			Dec null
			Inc null
		<= Height_label $mol_paragraph
			title \Высота
		<= Height $mol_number
			value? <=> height?
			Dec null
			Inc null
		<= Ratio_label $mol_paragraph
			title \Соотношение
		<= Ratio $mol_select
			value? <=> ratio_str? \16:9
			Filter null
			options /
				\16:9
				\Произвольно
	auto /
		^
		<= save_last_size null
